import { ssrApi } from 'api/ssr';
import {
  CollectionCasinoIdPage,
  Props,
} from 'components/template/collection-casino-id';
import { ParsedUrlQuery } from 'querystring';
import { isValidEntity, notFoundResult } from 'utils/ssr-not-found';
import { getCollectionIdentifier } from 'utils/slug';

export default function CollectionCasino({
  casinos,
  casinosCount,
  collection,
}: Props) {
  return (
    <CollectionCasinoIdPage
      collection={collection}
      casinos={casinos}
      casinosCount={casinosCount}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { name } = query;

  const collection = await ssrApi.casinoCollections.getByName(name?.toString());

  if (!isValidEntity(collection)) {
    return notFoundResult();
  }

  const collectionIdentifier = getCollectionIdentifier(collection);

  let casinosData;
  try {
    casinosData = await ssrApi.casinos.list({
      collections: collectionIdentifier,
      limit: 12,
      page: 1,
    });
  } catch {
    return notFoundResult();
  }

  return {
    props: {
      collection,
      casinos: casinosData.results ?? [],
      casinosCount: Number(
        casinosData.count ?? casinosData.results?.length ?? 0
      ),
    },
  };
}
